import React from 'react';
import { TiledImagesWidget } from './TiledImagesWidget.js';

var TiledImages = function (_a) {
    var caption = _a.caption, items = _a.items;
    var style = { borderRadius: 10, flex: 1, maxWidth: '100%' };
    var spotlight1 = {
        ImgWidget: function () { return React.createElement("img", { loading: "lazy", src: items[0].image, style: style, alt: "spt" }); },
    };
    var spotlight2 = {
        ImgWidget: function () { return React.createElement("img", { loading: "lazy", src: items[1].image, style: style, alt: "spt" }); },
    };
    var spotlight3 = {
        ImgWidget: function () { return React.createElement("img", { loading: "lazy", src: items[2].image, style: style, alt: "spt" }); },
    };
    return (React.createElement(TiledImagesWidget, { caption: caption, spotlight1: spotlight1, spotlight2: spotlight2, spotlight3: spotlight3 }));
};

export { TiledImages };
//# sourceMappingURL=index.js.map
